import React from "react";
import DocSyncCheck from "components/app/tool/docSyncCheck/DocSyncCheck";

type Props = {};

const ScreenDocSyncCheck = (props: Props) => {
	return <DocSyncCheck />;
};

export default ScreenDocSyncCheck;

